/*!
FullCalendar Multi-Month Plugin v6.1.15
Docs & License: https://fullcalendar.io/docs/multimonth-grid
(c) 2024 Adam Shaw
*/ FullCalendar.MultiMonth = function(t, e, l, i, n) {
    "use strict";
    class o extends i.DateComponent {
        constructor(){
            super(...arguments), this.buildDayTableModel = i.memoize(l.buildDayTableModel), this.slicer = new l.DayTableSlicer, this.state = {
                labelId: i.getUniqueDomId()
            };
        }
        render() {
            const { props: t, state: e, context: o } = this, { dateProfile: a, forPrint: r } = t, { options: s } = o, c = this.buildDayTableModel(a, o.dateProfileGenerator), d = this.slicer.sliceProps(t, a, s.nextDayThreshold, o, c), m = null != t.tableWidth ? t.tableWidth / s.aspectRatio : null, h = c.cells.length, u = null != m ? m / h : null;
            return n.createElement("div", {
                ref: t.elRef,
                "data-date": t.isoDateStr,
                className: "fc-multimonth-month",
                style: {
                    width: t.width
                },
                role: "grid",
                "aria-labelledby": e.labelId
            }, n.createElement("div", {
                className: "fc-multimonth-header",
                style: {
                    marginBottom: u
                },
                role: "presentation"
            }, n.createElement("div", {
                className: "fc-multimonth-title",
                id: e.labelId
            }, o.dateEnv.format(t.dateProfile.currentRange.start, t.titleFormat)), n.createElement("table", {
                className: [
                    "fc-multimonth-header-table",
                    o.theme.getClass("table")
                ].join(" "),
                role: "presentation"
            }, n.createElement("thead", {
                role: "rowgroup"
            }, n.createElement(i.DayHeader, {
                dateProfile: t.dateProfile,
                dates: c.headerDates,
                datesRepDistinctDays: !1
            })))), n.createElement("div", {
                className: [
                    "fc-multimonth-daygrid",
                    "fc-daygrid",
                    "fc-daygrid-body",
                    !r && "fc-daygrid-body-balanced",
                    r && "fc-daygrid-body-unbalanced",
                    r && "fc-daygrid-body-natural"
                ].join(" "),
                style: {
                    marginTop: -u
                }
            }, n.createElement("table", {
                className: [
                    "fc-multimonth-daygrid-table",
                    o.theme.getClass("table")
                ].join(" "),
                style: {
                    height: r ? "" : m
                },
                role: "presentation"
            }, n.createElement("tbody", {
                role: "rowgroup"
            }, n.createElement(l.TableRows, Object.assign({}, d, {
                dateProfile: a,
                cells: c.cells,
                eventSelection: t.eventSelection,
                dayMaxEvents: !r,
                dayMaxEventRows: !r,
                showWeekNumbers: s.weekNumbers,
                clientWidth: t.clientWidth,
                clientHeight: t.clientHeight,
                forPrint: r
            }))))));
        }
    }
    class a extends i.DateComponent {
        constructor(){
            super(...arguments), this.splitDateProfileByMonth = i.memoize(s), this.buildMonthFormat = i.memoize(m), this.scrollElRef = n.createRef(), this.firstMonthElRef = n.createRef(), this.needsScrollReset = !1, this.handleSizing = (t)=>{
                t && this.updateSize();
            };
        }
        render() {
            const { context: t, props: e, state: l } = this, { options: a } = t, { clientWidth: r, clientHeight: s } = l, c = l.monthHPadding || 0, d = Math.min(null != r ? Math.floor(r / (a.multiMonthMinWidth + c)) : 1, a.multiMonthMaxColumns) || 1, m = 100 / d + "%", h = null == r ? null : r / d - c, u = null != r && 1 === d, f = this.splitDateProfileByMonth(t.dateProfileGenerator, e.dateProfile, t.dateEnv, !u && a.fixedWeekCount, a.showNonCurrentDates), g = this.buildMonthFormat(a.multiMonthTitleFormat, f), p = [
                "fc-multimonth",
                u ? "fc-multimonth-singlecol" : "fc-multimonth-multicol",
                null != h && h < 400 ? "fc-multimonth-compact" : "",
                e.isHeightAuto ? "" : "fc-scroller"
            ];
            return n.createElement(i.ViewContainer, {
                elRef: this.scrollElRef,
                elClasses: p,
                viewSpec: t.viewSpec
            }, f.map((t, l)=>{
                const a = i.formatIsoMonthStr(t.currentRange.start);
                return n.createElement(o, Object.assign({}, e, {
                    key: a,
                    isoDateStr: a,
                    elRef: 0 === l ? this.firstMonthElRef : void 0,
                    titleFormat: g,
                    dateProfile: t,
                    width: m,
                    tableWidth: h,
                    clientWidth: r,
                    clientHeight: s
                }));
            }));
        }
        componentDidMount() {
            this.updateSize(), this.context.addResizeHandler(this.handleSizing), this.requestScrollReset();
        }
        componentDidUpdate(t) {
            i.isPropsEqual(t, this.props) || this.handleSizing(!1), t.dateProfile !== this.props.dateProfile ? this.requestScrollReset() : this.flushScrollReset();
        }
        componentWillUnmount() {
            this.context.removeResizeHandler(this.handleSizing);
        }
        updateSize() {
            const t = this.scrollElRef.current, e = this.firstMonthElRef.current;
            t && this.setState({
                clientWidth: t.clientWidth,
                clientHeight: t.clientHeight
            }), e && t && null == this.state.monthHPadding && this.setState({
                monthHPadding: t.clientWidth - e.firstChild.offsetWidth
            });
        }
        requestScrollReset() {
            this.needsScrollReset = !0, this.flushScrollReset();
        }
        flushScrollReset() {
            if (this.needsScrollReset && null != this.state.monthHPadding) {
                const { currentDate: t } = this.props.dateProfile, e = this.scrollElRef.current, l = e.querySelector(`[data-date="${i.formatIsoMonthStr(t)}"]`);
                e.scrollTop = l.getBoundingClientRect().top - this.firstMonthElRef.current.getBoundingClientRect().top, this.needsScrollReset = !1;
            }
        }
        shouldComponentUpdate() {
            return !0;
        }
    }
    const r = i.createDuration(1, "month");
    function s(t, e, n, o, a) {
        const { start: s, end: c } = e.currentRange;
        let d = s;
        const m = [];
        for(; d.valueOf() < c.valueOf();){
            const s = n.add(d, r), c = {
                start: t.skipHiddenDays(d),
                end: t.skipHiddenDays(s, -1, !0)
            };
            let h = l.buildDayTableRenderRange({
                currentRange: c,
                snapToWeek: !0,
                fixedWeekCount: o,
                dateEnv: n
            });
            h = {
                start: t.skipHiddenDays(h.start),
                end: t.skipHiddenDays(h.end, -1, !0)
            };
            const u = e.activeRange ? i.intersectRanges(e.activeRange, a ? h : c) : null;
            m.push({
                currentDate: e.currentDate,
                isValid: e.isValid,
                validRange: e.validRange,
                renderRange: h,
                activeRange: u,
                currentRange: c,
                currentRangeUnit: "month",
                isRangeAllDay: !0,
                dateIncrement: e.dateIncrement,
                slotMinTime: e.slotMaxTime,
                slotMaxTime: e.slotMinTime
            }), d = s;
        }
        return m;
    }
    const c = i.createFormatter({
        year: "numeric",
        month: "long"
    }), d = i.createFormatter({
        month: "long"
    });
    function m(t, e) {
        return t || (e[0].currentRange.start.getUTCFullYear() !== e[e.length - 1].currentRange.start.getUTCFullYear() ? c : d);
    }
    const h = {
        multiMonthTitleFormat: i.createFormatter,
        multiMonthMaxColumns: Number,
        multiMonthMinWidth: Number
    };
    i.injectStyles(".fc .fc-multimonth{border:1px solid var(--fc-border-color);display:flex;flex-wrap:wrap;overflow-x:hidden;overflow-y:auto}.fc .fc-multimonth-title{font-size:1.2em;font-weight:700;padding:1em 0;text-align:center}.fc .fc-multimonth-daygrid{background:var(--fc-page-bg-color)}.fc .fc-multimonth-daygrid-table,.fc .fc-multimonth-header-table{table-layout:fixed;width:100%}.fc .fc-multimonth-daygrid-table{border-top-style:hidden!important}.fc .fc-multimonth-singlecol .fc-multimonth{position:relative}.fc .fc-multimonth-singlecol .fc-multimonth-header{background:var(--fc-page-bg-color);position:relative;top:0;z-index:2}.fc .fc-multimonth-singlecol .fc-multimonth-daygrid{position:relative;z-index:1}.fc .fc-multimonth-singlecol .fc-multimonth-daygrid-table,.fc .fc-multimonth-singlecol .fc-multimonth-header-table{border-left-style:hidden;border-right-style:hidden}.fc .fc-multimonth-singlecol .fc-multimonth-month:last-child .fc-multimonth-daygrid-table{border-bottom-style:hidden}.fc .fc-multimonth-multicol{line-height:1}.fc .fc-multimonth-multicol .fc-multimonth-month{padding:0 1.2em 1.2em}.fc .fc-multimonth-multicol .fc-daygrid-more-link{border:1px solid var(--fc-event-border-color);display:block;float:none;padding:1px}.fc .fc-multimonth-compact{line-height:1}.fc .fc-multimonth-compact .fc-multimonth-daygrid-table,.fc .fc-multimonth-compact .fc-multimonth-header-table{font-size:.9em}.fc-media-screen .fc-multimonth-singlecol .fc-multimonth-header{position:sticky}.fc-media-print .fc-multimonth{overflow:visible}");
    var u = e.createPlugin({
        name: "@fullcalendar/multimonth",
        initialView: "multiMonthYear",
        optionRefiners: h,
        views: {
            multiMonth: {
                component: a,
                dateProfileGeneratorClass: l.TableDateProfileGenerator,
                multiMonthMinWidth: 350,
                multiMonthMaxColumns: 3
            },
            multiMonthYear: {
                type: "multiMonth",
                duration: {
                    years: 1
                },
                fixedWeekCount: !0,
                showNonCurrentDates: !1
            }
        }
    });
    return e.globalPlugins.push(u), t.default = u, Object.defineProperty(t, "__esModule", {
        value: !0
    }), t;
}({}, FullCalendar, FullCalendar.DayGrid.Internal, FullCalendar.Internal, FullCalendar.Preact);

//# sourceMappingURL=index.7f015d39.js.map
